import { render, staticRenderFns } from "./BranchItemSimpleCard.vue?vue&type=template&id=1baa32dc&scoped=true"
import script from "./BranchItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./BranchItemSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./BranchItemSimpleCard.vue?vue&type=style&index=0&id=1baa32dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa32dc",
  null
  
)

export default component.exports